import type {
  ICustomFieldsTicketForm,
  ITicketFormData,
} from "app/containers/Features/containers/Boards/containers/Tickets/types";
import { TicketField } from "app/containers/Features/containers/TeamSettings/container/Projects/container/WorkItems/types";
import React from "react";
import RenderFields from "app/containers/Features/containers/Ticket/components/Content/components/Details/components/CustomField/components/RenderFields";

type CustomFieldValue = string | number | boolean | Date | string[];

interface Props {
  customFields?: TicketField[];
  form?: ITicketFormData;
  onChange?: (data: ICustomFieldsTicketForm, shouldSave?: boolean) => void;
}

const Index: React.FC<Props> = ({ customFields, form, onChange }) => {
  const onChangeField = (
    fieldId: string,
    value: CustomFieldValue,
    shouldSave = false,
  ) => {
    if (onChange) {
      onChange({ fieldId, value }, shouldSave);
    }
  };

  if (!customFields?.length) return null;

  return (
    <div className="flex flex-col gap-[4px] w-full">
      <p className="text-xs leading-[21px] font-medium text-black">
        Custom fields
      </p>
      <div className="flex flex-col">
        {customFields.map((field, index) => {
          const isFirst = index === 0;
          const isLast = index === customFields.length - 1;
          return (
            <RenderFields
              fields={field}
              form={form as ITicketFormData}
              onChangeField={onChangeField}
              isFirst={isFirst}
              isLast={isLast}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Index;
